import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLang, LANG_TYPE, setLang } from '@tencent/oneid-utils';
import JSRuntime from 'common/utils/JSRuntime';
import { LANG_STORAGE_KEY } from './constant';
import enUSCommon from './en-US/common';

const lng = getLang(LANG_STORAGE_KEY, JSRuntime.isIntl);

setLang(LANG_STORAGE_KEY, lng, {
  // 写入根域名，避免多级域名导致无法获取到语言偏好
  domain: `.${window.location.hostname.split('.').slice(-2).join('.')}`,
  init: true,
});

i18n.use(initReactI18next).init({
  resources: {
    [LANG_TYPE.EN_US]: {
      common: enUSCommon,
    },
  },
  lng,
  fallbackLng: LANG_TYPE.ZH_CN,
  defaultNS: 'common',
  ns: ['common'],
  nsSeparator: false,
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    prefix: '{',
    suffix: '}',
  },
});

/**
 * 供子应用在 bootstrap 中动态注册自己的翻译资源
 * @param ns namespace 名称（如 'admin'、'idp'、'portal'）
 * @param resources 翻译资源对象
 * @param lang 语言类型
 */
export const addResources = (
  ns: string,
  resources: Record<string, string>,
  lang = LANG_TYPE.EN_US,
): void => {
  i18n.addResourceBundle(lang, ns, resources, true, true);
};

/**
 * 切换语言并持久化到 localStorage
 * @param lang 目标语言
 */
export const changeLanguage = async (lang: LANG_TYPE): Promise<void> => {
  localStorage.setItem(LANG_STORAGE_KEY, lang);
  await i18n.changeLanguage(lang);
};

/**
 * 根据当前语言设置 document.title 与 <html lang>
 * @param titleKey 翻译资源中的 key（优先使用 common ns）
 * @param ns 指定命名空间，不传则使用默认 ns
 */
export const setDocumentTitle = (titleKey: string, ns?: string): void => {
  document.title = ns ? i18n.t(titleKey, { ns }) : i18n.t(titleKey);
  document.documentElement.lang = i18n.language;
};

export default i18n;
